/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/img-redundant-alt */
import {
  collection,
  getDocs,
  query,
  where,
} from "firebase/firestore";

import { useState, useEffect } from "react";

import $ from 'jquery';
import AOS from 'aos';
import "./Actualite.css";
import Footer from '../Footer/Footer';
import Navigateur2 from '../../Header/Navigateur2';
import ScrollToTop from '../ScrollToTop/ScrollToTop';
import { Link } from 'react-router-dom';
import { db } from "../../firebase";
import { useParams } from "react-router-dom";

const Master = () => {

    const { id } = useParams();

    const [blogs, setBlogs] = useState([]);

    const getTrendingBlogs = async () => {

      const blogRef = collection(db, "master");
      const trendQuery = query(
        blogRef,
        where("id", "==", id)
      );
      const querySnapshot = await getDocs(trendQuery);
      let trendBlogs = [];
      querySnapshot.forEach((doc) => {
        trendBlogs.push({ id: doc.id, ...doc.data() });
      });
      setBlogs(trendBlogs);

       console.log(trendBlogs)

       console.log(blogs)

    };

    useEffect(() => {
      getTrendingBlogs();
    }, []);

    useEffect (()=>{

      $(window).on('load', function() {
        AOS.init();
        stylePreloader();
      });
    
      // Preloader
      function stylePreloader() {
        $('body').addClass('preloader-deactive');
      }
    
      // Scroll Top Hide Show
      $(window).on('scroll', function(){
        if ($(this).scrollTop() > 250) {
          $('.scroll-to-top').fadeIn();
        } else {
          $('.scroll-to-top').fadeOut();
        }
    
        // Sticky Header
        if($('.sticky-header').length){
          var windowpos = $(this).scrollTop();
          if (windowpos >= 80) {
            $('.sticky-header').addClass('sticky');
          } else {
            $('.sticky-header').removeClass('sticky');
          }
        }
    
      });
    
      //Scroll To Top
      $('.scroll-to-top').on('click', function(){
        $('html, body').animate({scrollTop : 0},800);
        return false;
      });
    
      // Reveal Footer JS
      let revealId = $(".reveal-footer"),
         footerHeight = revealId.outerHeight(),
         windowWidth = $(window).width(),
         windowHeight = $(window).outerHeight();
    
      if (windowWidth > 991 && windowHeight > footerHeight) {
        $(".site-wrapper-reveal").css({
          'margin-bottom': footerHeight + 'px'
        });
      }
    
      $(window).on('scroll', function() {
      });
      
      $(window).on('resize', function() {
      });

    
      
    },[]);
      
    return (
      <body>
        <div className="wrapper">

          <Navigateur2/>

          <main
            className="main-content site-wrapper-reveal"
            style={{ paddingTop: 120 }}
          >
            <section className="page-title-area">
              <div className="container">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="page-title-content content-style3">
                      <div className="bread-crumbs bread-crumbs-style2">
                        <Link to={"/"}>
                          <a>
                            Acceuil<span className="breadcrumb-sep">/</span>
                          </a>
                        </Link>
                        <span className="active text-black">Master</span>
                      </div>
                      <h4 className="title">
                        Profile du <span>candidat(e)</span>
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section
              className="blog-area pb-sm-70 pb-lg-90"
              data-padding-bottom="137"
            >
              <div className="container">
                <div className="row">
                  <div className="col-lg-8">
                    {blogs.map((item) => {
                      return (
                        <div className="post-items-style2" key={item.id}>
                          <div className="post-item">
                            
                            <div className="thumb">
                              <a>
                                <img
                                  src={item.photo}
                                  alt={item.photo}
                                  style={{
                                     height:'95%',
                                     width :'85%'
                                  }}
                                  // className="most-popular-img"
                                />
                              </a>
                            </div>

                            <div className="content">

                              <div className="col-lg-12">
                                <div className="page-title-content content-style3">
                                  <h4 >
                                   {item.Nom}
                                  </h4>
                                </div>

                                
                                <div className="page-title-content content-style3">
                                  <h5 >
                                   Date de Naissance :  {item.datenaissance}
                                  </h5>
                                </div>

                                <div className="page-title-content content-style3">
                                  <h5 >
                                    {item.filiere}
                                  </h5>
                                </div>

                                <div className="page-title-content content-style3">
                                  <h5 >
                                    Option : {item.Option}
                                  </h5>
                                </div>

                              </div>

                              <a>-----------------------</a>
                              <h6 className="title" style={{marginBottom:-2}}>
                                THÈME:{item.theme}
                              </h6>
                              <a>-----------------------</a>

                              <div>
                                <a style={{color:'green'}}>MENTION : {item.mention}</a> | <a style={{color:'red'}}>ANNEE D'ETUDE : {item.anneetude}</a> 
                              </div>

                            </div>
                          </div>
                        </div>
                      );
                    })}
                    <div className="pagination-area mb-md-80">
                      <nav>
                        <ul className="page-numbers">
                          <li>
                            <span className="page-number current">1</span>
                          </li>
                          <li>
                            <a className="page-number" href="#">
                              2
                            </a>
                          </li>
                          <li>
                            <a className="page-number" href="#">
                              3
                            </a>
                          </li>
                          <li>
                            <a className="page-number" href="#">
                              4
                            </a>
                          </li>
                          <li>
                            <a className="page-number next" href="#">
                              <i className="icofont-thin-right"></i>
                            </a>
                          </li>
                        </ul>
                      </nav>
                    </div>

                  </div>

                  <div className="col-lg-4">
                    <div className="sidebar-wrapper blog-sidebar-wrapper">
                      <div className="widget-item">
                        <h4
                          className="widget-title"
                          style={{
                            color: "#000000",
                          }}
                        >
                          CHERCHER
                        </h4>
                        <div className="widget-search-box">
                          <form action="#" method="post">
                            <input
                              type="text"
                              id="search"
                              placeholder="Recherche..."
                            ></input>
                          </form>
                        </div>
                      </div>

                      <div className="widget-item">
                        <h4
                          className="widget-title"
                          style={{
                            color: "#000000",
                          }}
                        >
                          CATÉGORIES
                        </h4>
                        <div className="widget-categories">
                          <ul>
                            <li>
                              <a href="#/">
                                Tout <span>1</span>
                              </a>
                            </li>
                            <li>
                              <a href="#/">
                                Nouvelles <span>0</span>
                              </a>
                            </li>
                            <li>
                              <a href="#/">
                                Stage <span>0</span>
                              </a>
                            </li>
                            <li>
                              <a href="#/">
                                Autres <span>0</span>
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>

                      <div className="widget-item">
                        <h4
                          className="widget-title"
                          style={{
                            color: "#000000",
                          }}
                        >
                          MOTS CLÉS
                        </h4>
                        <div className="widget-tags tags-style2">
                          <ul>
                            <li>
                              <a href="#/">DG</a>
                            </li>
                            <li>
                              <a href="#/">SGAC</a>
                            </li>
                            <li>
                              <a href="#/">SGR</a>
                            </li>
                            <li>
                              <a href="#/">Autres</a>
                            </li>
                            <li>
                              <a href="#/"></a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>

            </section>
            
            
          </main>


          <Footer />

          <ScrollToTop />
        </div>
      </body>
    );

};

export default Master;